var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftPanelClose = function SvgLeftPanelClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.596 11.173V4.827L8.404 8zM1.616 16q-.672 0-1.144-.472A1.56 1.56 0 0 1 0 14.384V1.616Q0 .944.472.472A1.56 1.56 0 0 1 1.616 0h12.768q.672 0 1.144.472T16 1.616v12.768q0 .672-.472 1.144a1.56 1.56 0 0 1-1.144.472zM4 15V1H1.616a.59.59 0 0 0-.424.192.59.59 0 0 0-.192.424v12.768q0 .232.192.424.193.192.424.192zm1 0h9.385a.59.59 0 0 0 .423-.192.59.59 0 0 0 .192-.424V1.616a.59.59 0 0 0-.192-.424.59.59 0 0 0-.424-.192H5z"
  })));
};
export default SvgLeftPanelClose;